import React from "react"

const SocialIconLinkedIn = ({
  className = "",
  width = "auto",
  height = "auto",
  fill,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4 0H1.71C.797 0 0 .656 0 1.558v16.728C0 19.192.797 20 1.709 20h16.686c.918 0 1.605-.813 1.605-1.714V1.558C20.005.656 19.312 0 18.4 0zM6.2 16.671H3.334V7.762H6.2v8.909zM4.866 6.408h-.02c-.917 0-1.511-.683-1.511-1.537 0-.87.61-1.537 1.547-1.537.937 0 1.51.662 1.531 1.537 0 .854-.594 1.537-1.547 1.537zm11.805 10.263h-2.865V11.8c0-1.167-.417-1.964-1.454-1.964-.792 0-1.26.535-1.469 1.057-.078.188-.1.443-.1.704v5.074H7.92V7.762h2.865v1.24c.417-.594 1.068-1.448 2.584-1.448 1.88 0 3.303 1.24 3.303 3.912v5.205z"
        fill={fill}
      />
    </svg>
  )
}

export default SocialIconLinkedIn
